module.exports = __webpack_public_path__ + "assets/img/Arrival Plaza.6cd8e4d3.jpg";